var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenerateAndOutshine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 84.7712C174.841 85.1682 174.67 85.5596 174.527 85.9623C173.28 89.5696 169.994 92.0028 166.252 92.0652C162.368 92.1333 158.94 89.8929 157.67 86.2402C157.282 85.1285 156.741 84.9073 155.676 84.913C145.618 84.947 135.566 84.9357 125.509 84.93C123.692 84.93 123.128 84.4763 123.128 83.115C123.128 81.992 123.703 81.3795 124.808 81.3341C125.93 81.2887 127.052 81.3171 128.174 81.3171C137.4 81.3171 146.627 81.3171 155.853 81.3171C156.565 81.3171 157.157 81.4248 157.51 80.4039C158.917 76.3372 162.26 74.1025 166.434 74.2329C170.37 74.3577 173.525 76.9498 174.732 81.0505C174.784 81.2263 174.903 81.3851 174.994 81.5553V84.7655L175 84.7712Z",
    fill: "url(#paint0_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2739 137.258H52.6673C52.6673 136.408 52.6445 135.602 52.6673 134.797C52.7869 130.776 51.1524 127.735 47.8264 125.41C35.5703 116.817 27.8875 105.122 25.7006 90.3808C22.6479 69.775 29.6075 52.7652 45.9754 39.788C54.41 33.1009 64.2228 29.6638 74.9925 29.0115C75.374 28.9889 75.7613 29.0115 76.3024 29.0115C76.3308 29.5334 76.3764 29.9984 76.3764 30.4635C76.3764 40.0433 76.365 49.623 76.3992 59.2027C76.3992 60.2463 76.1941 60.7171 75.0095 60.8589C64.183 62.1634 55.8566 71.5049 55.5092 82.6501C55.1789 93.3074 62.9756 103.114 73.4491 105.196C74.3546 105.377 75.2658 105.508 76.2739 105.678V137.258Z",
    fill: "url(#paint1_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1467 42.0621C80.289 41.994 80.3289 41.96 80.3745 41.96C84.6174 41.648 84.7882 41.6423 84.9705 45.8282C85.1129 49.1121 85.9785 51.3695 89.6804 51.9197C91.1612 52.1409 92.5963 53.02 93.9347 53.8028C95.4098 54.6705 96.5887 54.6252 97.8986 53.4795C99.4648 52.1069 101.179 50.9044 102.717 49.7134C105.741 52.7138 108.674 55.6177 111.778 58.6919C110.599 60.1949 109.346 61.9191 107.962 63.5186C106.886 64.7607 106.8 65.8497 107.563 67.3414C108.64 69.4513 109.5 71.686 110.28 73.9264C110.747 75.2706 111.504 75.9059 112.9 76.0136C114.745 76.1611 116.585 76.439 118.43 76.6376C119.119 76.7113 119.603 76.8417 119.597 77.7436C119.557 81.5834 119.58 85.4232 119.58 89.4559C117.325 89.7452 115.127 90.0968 112.911 90.2896C111.499 90.4088 110.758 91.0327 110.286 92.3599C109.454 94.6853 108.52 96.9824 107.444 99.2114C106.829 100.493 106.886 101.457 107.785 102.535C109.186 104.208 110.491 105.967 111.789 107.623C108.737 110.606 105.758 113.527 102.665 116.55C101.088 115.325 99.2939 113.992 97.5739 112.574C96.526 111.712 95.5863 111.695 94.3619 112.268C92.0781 113.34 89.726 114.287 87.3511 115.144C86.138 115.58 85.4887 116.25 85.3635 117.526C85.1812 119.415 84.9021 121.292 84.7199 123.175C84.6402 123.992 84.3839 124.411 83.467 124.36C82.3621 124.292 81.2458 124.343 80.0726 124.343V105.717C81.2174 105.502 82.3678 105.343 83.4897 105.065C94.1739 102.456 101.395 92.7966 100.826 81.901C100.262 71.1359 92.0496 62.3105 81.1832 60.8131C80.5055 60.7224 79.9929 60.66 79.9986 59.7412C80.0384 53.9502 80.0328 48.165 80.0441 42.374C80.0441 42.2833 80.1068 42.1982 80.158 42.0621H80.1467Z",
    fill: "url(#paint2_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0508 102.087C67.4065 101.962 59.0403 93.4887 59.1485 82.9504C59.2567 72.4405 67.959 63.9612 78.4324 64.1597C88.9344 64.3582 97.3519 72.9397 97.2323 83.3305C97.1127 93.7496 88.4617 102.212 78.0508 102.087Z",
    fill: "url(#paint3_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1418 154.659C69.8439 154.659 61.5517 154.654 53.2538 154.659C51.4655 154.659 49.757 154.444 48.2591 153.355C45.8842 151.619 44.842 148.63 45.6678 145.857C46.5278 142.987 48.9369 141.092 52.018 140.877C52.4052 140.848 52.7982 140.86 53.1912 140.86C69.8325 140.86 86.4739 140.854 103.115 140.877C104.129 140.877 105.183 140.962 106.145 141.251C109.351 142.221 111.242 145.329 110.832 148.749C110.462 151.818 107.842 154.296 104.642 154.58C103.964 154.642 103.275 154.648 102.597 154.648C94.4471 154.648 86.2973 154.648 78.1475 154.648L78.1418 154.659Z",
    fill: "url(#paint4_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.56 158.357C103.394 164.863 98.0125 170.688 91.6111 170.841C82.6355 171.057 73.6484 171.062 64.6728 170.835C58.2999 170.677 52.4509 164.273 52.8496 158.357H103.554H103.56Z",
    fill: "url(#paint5_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.602 65.9632C129.985 65.9632 126.375 65.9632 122.758 65.9632C121.784 65.9632 120.873 65.8271 120.497 64.7494C120.059 63.4846 120.901 62.407 122.428 62.3673C124.136 62.3219 125.845 62.3559 127.553 62.3559C132.782 62.3559 138.004 62.3276 143.232 62.3786C144.314 62.39 144.855 62.1291 145.226 61.0344C146.479 57.308 147.84 53.6156 149.224 49.9289C149.548 49.0668 149.451 48.5904 148.7 47.9892C145.505 45.4255 144.48 41.2851 146.023 37.6097C147.583 33.8833 151.302 31.7621 155.471 32.2101C159.293 32.6242 162.425 35.6076 163.171 39.5495C164.174 44.8527 159.965 49.9346 154.423 49.98C153.29 49.9913 152.823 50.3487 152.47 51.3639C151.154 55.1754 149.77 58.9585 148.381 62.7473C147.401 65.413 146.575 65.9689 143.705 65.9689C140.333 65.9689 136.968 65.9689 133.596 65.9689L133.602 65.9632Z",
    fill: "url(#paint6_linear_64_7690)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 116.171C154.207 116.307 155.335 116.329 156.417 116.573C160.472 117.498 163.291 121.116 163.274 125.263C163.257 129.443 160.358 132.982 156.177 133.935C152.248 134.831 148.079 132.817 146.273 129.165C144.44 125.45 145.368 120.941 148.62 118.366C149.417 117.736 149.571 117.254 149.218 116.324C147.823 112.648 146.479 108.95 145.209 105.235C144.867 104.231 144.394 103.908 143.34 103.919C136.706 103.965 130.065 103.948 123.43 103.942C122.895 103.942 122.217 104.084 121.858 103.823C121.266 103.392 120.554 102.706 120.508 102.087C120.474 101.56 121.232 100.874 121.79 100.448C122.114 100.204 122.73 100.324 123.214 100.324C130.093 100.324 136.973 100.324 143.859 100.324C146.507 100.324 147.424 100.93 148.335 103.409C149.725 107.192 151.075 110.987 152.447 114.775C152.629 115.274 152.829 115.768 152.988 116.176V116.171Z",
    fill: "url(#paint7_linear_64_7690)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_7690",
    x1: 149.064,
    y1: 74.2275,
    x2: 149.064,
    y2: 92.0667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_7690",
    x1: 50.6998,
    y1: 29.0015,
    x2: 50.6998,
    y2: 137.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_7690",
    x1: 99.7979,
    y1: 41.8398,
    x2: 99.7979,
    y2: 124.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_64_7690",
    x1: 78.1905,
    y1: 64.1562,
    x2: 78.1905,
    y2: 102.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_64_7690",
    x1: 78.1378,
    y1: 140.857,
    x2: 78.1378,
    y2: 154.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_64_7690",
    x1: 78.195,
    y1: 158.357,
    x2: 78.195,
    y2: 171.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_64_7690",
    x1: 141.85,
    y1: 32.1509,
    x2: 141.85,
    y2: 65.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_64_7690",
    x1: 141.891,
    y1: 100.294,
    x2: 141.891,
    y2: 134.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 142,
    fill: "white",
    transform: "translate(25 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateAndOutshine);
export default __webpack_public_path__ + "static/media/Generate_and_outshine.8e77f63a046d392e6d48bac38e5b94ea.svg";
export { ForwardRef as ReactComponent };